<template>
  <svg
    width="16"
    height="16"
    viewBox="0 0 16 16"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
  >
    <path
      d="M8 -0.000732422C3.58095 -0.000732422 0 3.58022 0 7.99927C0 12.4183 3.58095 15.9993 8 15.9993C9.6 15.9993 11.2 15.5421 12.4952 14.6278L11.2 12.7231C10.2857 13.3326 9.14286 13.7136 8 13.7136C4.87619 13.7136 2.28571 11.1231 2.28571 7.99927C2.28571 4.87546 4.87619 2.28498 8 2.28498C11.1238 2.28498 13.7143 4.87546 13.7143 7.99927V8.60879C13.7143 9.06593 13.6381 9.90403 12.8762 9.90403H12.5714C12.3429 9.90403 11.8857 9.44689 11.8857 9.21832V7.99927C11.8857 5.86593 10.1333 4.11355 8 4.11355C5.86667 4.11355 4.11429 5.86593 4.11429 7.99927C4.11429 10.1326 5.86667 11.885 8 11.885C8.91429 11.885 9.67619 11.5802 10.3619 11.0469C10.9714 11.7326 11.7333 12.1897 12.5714 12.1897H12.8762C14.7048 12.1897 16 10.7421 16 8.60879V7.99927C16 3.58022 12.419 -0.000732422 8 -0.000732422ZM8 9.59927C7.08571 9.59927 6.4 8.91355 6.4 7.99927C6.4 7.08498 7.08571 6.39927 8 6.39927C8.91429 6.39927 9.6 7.08498 9.6 7.99927C9.6 8.91355 8.91429 9.59927 8 9.59927Z"
      fill="black"
    />
  </svg>
</template>

<script>
export default {
  name: 'IconEmail',
};
</script>
